import { api } from "aldoo-ra/API"

const receiveLinkAPI = api("receive-link")
const receiveAPI = api("receive")

export async function listLinks() {
  return receiveLinkAPI({ list: {} })
}

export async function createLink(payload) {
  return receiveLinkAPI({ create: payload })
}

export async function updateLink(linkId, patch) {
  return receiveLinkAPI({ update: { linkId, patch } })
}

export async function setLinkStatus(linkId, op) {
  return receiveLinkAPI({ status: { linkId, op } })
}

export async function getLinkInfo(token) {
  return receiveLinkAPI({ info: { token } })
}

export async function listLinkTransfers(linkId) {
  return receiveLinkAPI({ transfers: { linkId } })
}

export async function sendLinkInvite(linkId, emails, message) {
  return receiveLinkAPI({ sendInvite: { linkId, emails, message } })
}

// Sender lifecycle.
export async function beginReceive(token, password) {
  return receiveAPI({ begin: { token, ...(password ? { password } : {}) } })
}

export async function finalizeReceive({ orderID, title, notes }) {
  return receiveAPI({ finalize: { orderID, title, notes } })
}

export async function listSentTransfers({ page = 1, itemsPerPage = 10, search } = {}) {
  return receiveAPI({ listSent: { page, itemsPerPage, search } })
}
